import setupallComponent from './setup.all.component';

let setupallModule = angular.module('setupall', [
  ])

  .component('setupall', setupallComponent)

  .name;

export default setupallModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/all/index.js